<div id="main" [class]="user.theme" (click)="onDocumentClick($event)">
  <p-toast baseZIndex="10000" position="top-right"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" acceptButtonStyleClass="btn btn-primary"
    rejectButtonStyleClass="btn btn-outline-primary"></p-confirmDialog>
  <ngx-header></ngx-header>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
  <ngx-footer></ngx-footer>
</div>